import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import MaterialKit from './plugins/material-kit'
import { Amplify } from 'aws-amplify';
import * as AmplifyModules from 'aws-amplify';
import awsExports from './aws-exports';
import './plugins/amplifyAuthEvents'

import { AmplifyPlugin } from 'aws-amplify-vue'
Amplify.configure({ ...awsExports, ssr: true });
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

Vue.use(MaterialKit)
Vue.use(AmplifyPlugin, AmplifyModules)
const NavbarStore = {
  showNavbar: false,
}

Vue.mixin({
  data() {
    return {
      NavbarStore,
    }
  },
})

// 文字列置換なのでデフォルトの英文が変更されたら、それに合わせて修正しないとダメ！
let languageDict = {
  ja: {
    Username: 'メールアドレスID',
    'Sign in to your account': 'ログイン',
    'Enter your username': 'メールアドレスIDを入力してください',
    Password: 'パスワード',
    'Enter your undefined': 'メールアドレスIDを入力してください',
    'New Password': '新しいパスワード',
    'Resend Code': ' www',
    'Confirmation Code': '認証コード',
    'Lost your code? ': ' ',
    'Enter your password': 'パスワードを入力してください',
    'User does not exist.': 'メールアドレスIDまたはパスワードが誤っています',
    'Incorrect username or password.': 'メールアドレスIDまたはパスワードが誤っています',
    Email: 'メールアドレスID',
    'Forgot your password? ': ' ',
    'Reset password': ' ',
    'No account? ': ' ',
    'Create account': ' ',
    'Sign In': 'ログイン',
    'Sign in': 'ログイン',
    'Create a new account': 'ユーザー新規作成',
    'Create Account': 'ユーザー新規作成',
    'Have an account? ': ' ',
    'Reset your password': 'パスワード再設定',
    'Back to Sign In': ' ',
    'Send Code': '認証コードの発行',
    Code: '認証コード',
    'Enter your Username': 'メールアドレスIDを入力してください',
    'New Password ': '新しいパスワード',
  },
}
AmplifyModules.I18n.putVocabularies(languageDict)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
